import Base from '../Base'

export class User extends Base {
  constructor(data, vm) {
    super(data, vm)
  }
  get id() {
    return this.data.id
  }

  get fullName() {
    return [this.firstName, this.lastName].join(' ')
  }

  get firstName() {
    return this.data.first_name
  }

  get lastName() {
    return this.data.last_name
  }

  get email() {
    return this.data.email
  }

}

export default User
